// import modular mixins
import pathMixin from "./pathMixin";
import forceKey from "./forceKey";
import forceClose from "./forceClose";

export default {

    //the following Mixins will be imported globally
    mixins: [
        pathMixin,
        forceKey,
        forceClose,
    ],
    data(){
        return{

        };
    },
    methods: {},
    computed: {},
}